/**
 * a-054: Zentrale Bild-URL-Auflösung. ASL-Bilder (wp-content/uploads) laufen über den
 * same-origin Proxy functions/media/[[path]].js (/media/asl/<pfad>) mit Edge-Cache.
 * Alle anderen URLs (R2-Uploads /media/content/..., relative/fremde Pfade) bleiben unverändert.
 */
export const ASL_UPLOAD_PREFIX = 'https://www.asl-ademco.de/wp-content/uploads/';
const PROXY_PREFIX = '/media/asl/';

/** @param {unknown} url @returns {string} Proxy-Pfad für ASL-Uploads, sonst die Eingabe (getrimmt) */
export function mediaUrl(url) {
  if (typeof url !== 'string') return '';
  const value = url.trim();
  if (!value) return '';
  if (!value.startsWith(ASL_UPLOAD_PREFIX)) return value;
  const rest = value.slice(ASL_UPLOAD_PREFIX.length).split('#')[0].split('?')[0];
  if (!rest) return value;
  // Segmente bereits kodiert übernehmen; Proxy dekodiert und prüft erneut.
  return PROXY_PREFIX + rest;
}

/** Bild-URL aus Eintrag (String oder {url}) mit mediaUrl(). */
export function mediaUrlOf(entry) {
  return mediaUrl(typeof entry === 'string' ? entry : entry?.url);
}
